import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { breacrumbTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

const BreadCrumb = (props) => {

    const crumbs = props.crumbs;

    return (
        crumbs.length > 0 ? (<div className="bread-crumb">
            <ul>
                <li>
                    <Link to="/">{breacrumbTxt.home}</Link>
                </li>
                {crumbs.map((crumb, i) =>
                    <li key={i}>
                        <Link to={crumb.url}>{crumb.title}</Link>
                    </li>
                )}
            </ul>
        </div>) : ""
    )
    
}
BreadCrumb.propTypes = {
    crumbs: PropTypes.array
}
export default BreadCrumb;
